<template>
  <div class="timbre overflow-hidden">
    <div class="absolute left-[6px] top-[6px]">
      <slot name="leftTop"> </slot>
    </div>
    <div class="absolute right-[6px] top-[6px]">
      <slot name="rightTop"> </slot>
    </div>

    <a-popover v-if="dataSource.isBrand">
      <template #content>{{ $t('pin-pai-gui-fan') }}</template>
      <span
        class="icon-item"
        :class="{
          '!left-[17px]': dataSource.is_new,
        }"
      >
        <iconpark-icon name="icon-crown" size="16"></iconpark-icon>
      </span>
    </a-popover>
    <div class="bg-back-1 w-[65px] h-[65px] rounded-full">
      <Resource
        :src="
          dataSource.cover || getFeUrl('/youyan-platform/png/voice-normal.png')
        "
        class="w-full h-full rounded-full"
      />
    </div>
    <div class="text-14 font-medium mt-[15px]">
      <img
        v-if="dataSource.configScenes?.flag_oss"
        :src="dataSource.configScenes?.flag_oss"
        class="w-[16px] h-[10px]"
      />
      {{ dataSource.title }}
    </div>
    <div
      class="text-12 text-font-60 mt-[2px] px-[12px] text-center"
      :class="{
        'line-clamp-2 break-words break-all': isGlobalVersion(),
      }"
    >
      {{
        isGlobalVersion()
          ? dataSource.configScenes?.subtitle_en
          : dataSource.configScenes?.subtitle
      }}
    </div>
    <div
      class="listen cursor-pointer"
      @click="() => playTimbre(dataSource.configScenes)"
    >
      <span
        v-if="!isPlay[dataSource.configScenes.id]"
        class="flex-y-center gap-[3px]"
      >
        <iconpark-icon
          size="16"
          class="audition"
          name="audition"
        ></iconpark-icon>
        {{ $t('shi-ting') }}
      </span>
      <div v-else><SoundWave /></div>
    </div>
    <audio
      :id="`timbre${dataSource.configScenes.id}`"
      ref="audioRef"
      controls
      class="hidden"
      @play="checkStatus(dataSource.configScenes.id, true)"
      @pause="checkStatus(dataSource.configScenes.id, false)"
      @ended="pauseTimbre(dataSource.configScenes.id)"
    >
      <source :src="dataSource.configScenes.url" />
    </audio>
  </div>
</template>
<script lang="ts" setup>
import SoundWave from './sound-wave.vue'

withDefaults(
  defineProps<{
    dataSource?: any
  }>(),
  {
    dataSource: () => ({}),
  }
)

const audioRef = ref()
const isPlay = ref<{ [key: number]: boolean }>({})

const checkStatus = (id: number, play: boolean) => {
  isPlay.value[id] = play
}

// 暂停播放
const pauseTimbre = (id: number) => {
  const dom: any = document.getElementById('timbre' + id)
  dom?.pause()
}
// 播放、暂停
const playTimbre = (item: { id: number; url: string }) => {
  checkPlay(item.id)
}

// 只允许一个播放
const checkPlay = (id: number) => {
  const videoElement = document.getElementsByTagName('audio')

  Array.from(videoElement).forEach((item) => {
    if (item.id === 'timbre' + id && item.paused) {
      item.play()
    } else {
      item.pause()
    }
  })
}
</script>
<style lang="scss" scoped>
.timbre {
  @apply flex flex-col items-center;
  background: var(--back-3);
  position: relative;
  border-radius: 8px;
  padding: 20px 0;
  border: 2px solid transparent;
  min-height: 200px;
  &:hover {
    border: 2px solid var(--purple-6);
  }
  .listen {
    @apply text-font-70 mt-[15px] flex-y-center justify-center;
    font-size: 12px;
    min-width: 69px;
    height: 23px;
    background: var(--back-1);
    box-shadow: 0px 2px 10px 0px rgba(0, 92, 207, 0.06);
    border-radius: 12px;
    padding: 4px 10px;
    .audition {
      color: var(--text-1-70);
    }
    &:hover {
      color: var(--purple-6);
      .audition {
        color: var(--purple-6);
      }
    }
  }
  .icon-item {
    @apply flex justify-center items-center w-[22px] h-[22px] rounded-[50%] text-center cursor-pointer text-primary absolute left-[6px] top-[6px];
    box-shadow: 0px 2px 6px 0px rgba(86, 80, 220, 0.1);
  }
}
</style>
